module.exports = __webpack_public_path__ + "img/user-doctor.03730b2f.svg";